import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { HOMEPAGE } from "../views/home/routes";
import { isRgbUserFromToken } from "../utils/authToken";
import { isTokenValid } from "../utils/isTokenValid";

type Props = { children: React.ReactElement };

/**
 * Rotas de vasilhame RGB: ADMIN, SUPERVISOR e SUPERVISOR_DE_CAMPO.
 *
 * Mesmo desenho do `DpRoute`: sem token vai ao login; com token de outro papel
 * (DP) vai à home, porque não é sessão inválida — é falta de permissão.
 */
const RgbRoute: React.FC<Props> = ({ children }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;
  if (!isTokenValid(token)) return <Navigate to={LOGINPAGE()} replace />;
  if (!isRgbUserFromToken(token)) return <Navigate to={HOMEPAGE()} replace />;

  return children;
};

export default RgbRoute;
